import { NoResultsFound } from '@/assets/icons/ats';
import { KText } from '@/ui-library/components/text';
import { Center, CenterProps, Icon, IconProps, Image } from '@chakra-ui/react';
import { SVGProps } from 'react';

interface EmptyResultsProps {
  image?: string;
  text?: React.ReactNode | string;
  placeholder?: React.ReactNode | string;
  placeholderProps?: any;
  wrapperProps?: CenterProps;
  // @ts-ignore
  icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  iconProps?: IconProps;
  textProps?: any;
  subText?: string;
  subTextProps?: any;
  showIcon?: boolean;
  TriggerComponent?: React.ReactNode;
  showText?: boolean;
}

export const EmptyResults = ({
  image,
  subText = '',
  text = 'No result found',
  showText = true,
  wrapperProps,
  placeholder,
  placeholderProps,
  iconProps,
  textProps,
  subTextProps,
  icon = NoResultsFound,
  showIcon = true,
  TriggerComponent,
}: EmptyResultsProps) => {
  return (
    <Center
      h="100%"
      minH="100%"
      w="100%"
      flexDir="column"
      justifyContent="center"
      gap={{ base: '8px', md: '10px' }}
      {...wrapperProps}
    >
      {showIcon && (
        <>
          {image ? (
            //@ts-ignore
            <Image
              src={image}
              w={{ base: '120px', md: '240px' }}
              h={{ base: '100px', md: '200px' }}
              mb={{ base: '16px', md: '36px' }}
              {...iconProps}
            />
          ) : (
            <Icon
              as={icon}
              w={{ base: '120px', md: '240px' }}
              h={{ base: '100px', md: '200px' }}
              mb={{ base: '16px', md: '36px' }}
              {...iconProps}
            />
          )}
        </>
      )}
      {placeholder && (
        <KText size="sm-medium" color="secondary-600" {...placeholderProps}>
          {placeholder}
        </KText>
      )}
      {subText && (
        <KText
          size="sm-medium"
          fontSize={'16px'}
          color="secondary-900"
          {...subTextProps}
        >
          {subText}
        </KText>
      )}
      {showText && (
        <KText size="sm-regular" color="secondary-900" {...textProps}>
          {text}
        </KText>
      )}
      {TriggerComponent && TriggerComponent}
    </Center>
  );
};
